import { IconType } from 'react-icons';
import { AiOutlineQuestion } from 'react-icons/ai';
import { action, makeObservable, observable } from 'mobx';
import { ToolExecuteHandler } from '../../constants';
import { t } from '../../stores/TranslateStore';

export default class ToolModel {
  readonly id: string;

  readonly iconType?: IconType;

  readonly text?: string

  @observable badge?: string = undefined;

  onExecute?: ToolExecuteHandler;

  constructor(
    id: string,
    icon: IconType,
    text: string,
    onExecute?: ToolExecuteHandler,
  ) {
    this.id = id;
    this.iconType = icon;
    this.text = text || '##';
    this.badge = '';
    this.onExecute = onExecute || (() => false);

    makeObservable(this);
  }

  @action
  public setBadgeText(text: string) {
    if (text === '0') this.badge = '';
    else {
      this.badge = text;
    }
  }

  get icon(): IconType {
    return this.iconType || AiOutlineQuestion;
  }

  // 표시 전용 번역 툴 라벨. 툴바 버튼명(조회·저장 등 정적 라벨)이라 번역에
  // 이상적이다. text(원문)는 그대로 두어 로직에 영향이 없다.
  get textT(): string {
    return t.T(this.text ?? '');
  }
}
